import React from 'react';

const Footer = () => {
  const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/2927c86c700ec49dd101b06d8f665ec936c446223b03db97ee166b3b81a38e088d244e0b8a3abf82b7f680071b9e9e7b/images/aW1hZ2UvcG5n/938af48630f3844187713f8a83e6a456.png";
  
  return (
    <footer className="bg-slate-900 text-slate-200 py-16 border-t border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-8 relative inline-block group">
              <div className="absolute inset-0 bg-white/10 blur-3xl rounded-full pointer-events-none -z-10 transition-colors duration-300 group-hover:bg-white/20"></div>
              <img 
                src={LOGO_URL} 
                alt="Secure Gold Investments" 
                className="h-28 md:h-36 w-auto object-contain drop-shadow-[0_0_20px_rgba(255,255,255,0.6)] transition-transform duration-300 group-hover:scale-105" 
              />
            </div>
            <p className="text-base text-slate-300 leading-relaxed max-w-md">
              SecureGoldInvestments.com empowers American investors with professional tools and institutional-grade insights to protect their retirement savings through strategic physical gold diversification.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><a href="#gold-ira-calculator" className="hover:text-yellow-400 transition-colors">Gold IRA Calculator</a></li>
              <li><a href="#guide" className="hover:text-yellow-400 transition-colors">Investment Guide</a></li>
              <li><a href="#faq" className="hover:text-yellow-400 transition-colors">Frequently Asked Questions</a></li>
              <li><a href="/best-gold-ira-companies" className="hover:text-yellow-400 transition-colors">Top Gold IRA Companies</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Legal & Risk</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Full Risk Disclosure</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors">Editorial Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-10 mt-10">
          <div className="flex flex-col gap-10 mb-12">
            {/* Advertiser Disclosure */}
            <div className="pb-10 border-b border-slate-800/60">
              <h5 className="text-white font-bold text-sm mb-4 uppercase tracking-widest flex items-center gap-2 font-serif">
                <span className="w-2.5 h-2.5 bg-yellow-500 rounded-full shadow-[0_0_8px_rgba(234,179,8,0.6)]"></span> Advertiser Disclosure
              </h5>
              <p className="text-[15px] text-slate-200 leading-relaxed font-medium">
                SecureGoldInvestments.com may receive compensation from some of the companies featured on this website. Compensation may impact how and where products appear on this site, including the order in which they appear. This site does not include all companies or all available offers.
              </p>
            </div>

            {/* Financial Disclaimer */}
            <div>
              <h5 className="text-slate-100 font-bold text-sm mb-4 uppercase tracking-widest font-serif">
                Important Financial Disclaimer
              </h5>
              <p className="text-sm text-slate-300 leading-relaxed">
                <strong className="text-white">Disclaimer:</strong> The information provided on SecureGoldInvestments.com, including but not limited to the Gold IRA Calculator and company reviews, is for educational and informational purposes only and does not constitute financial, investment, or tax advice. All investments carry risk, including the possible loss of principal. Past performance of gold, silver, or the stock market is not indicative of future results. We strongly recommend consulting with a qualified financial advisor, CPA, or legal professional before making any investment decisions or initiating an IRA rollover.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] text-slate-400 font-bold uppercase tracking-widest pt-8 border-t border-slate-800/40">
            <p>&copy; {new Date().getFullYear()} Secure Gold Investments. All rights reserved.</p>
            <p className="text-yellow-500/80">securegoldinvestments.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;